import { Card, CardContent } from "@/components/ui/card";
import "./index.css";

import logo from "./logo.svg";
import reactLogo from "./react.svg";
import DMKTest from "./components/DMKTest";

export function App() {
  return (
    <div className="container mx-auto p-8 text-center relative z-10">
      {/* <div className="flex justify-center items-center gap-8 mb-8">
        <img
          src={logo}
          alt="Bun Logo"
          className="h-36 p-6 transition-all duration-300 hover:drop-shadow-[0_0_2em_#646cffaa] scale-120"
        />
        <img
          src={reactLogo}
          alt="React Logo"
          className="h-36 p-6 transition-all duration-300 hover:drop-shadow-[0_0_2em_#61dafbaa] [animation:spin_20s_linear_infinite]"
        />
      </div> */}

      <Card className="bg-card/50 backdrop-blur-sm border-muted">
        <CardContent className="pt-6">
          <h1 className="text-5xl font-bold my-4 leading-tight">
            Ledger Device Management Kit
          </h1>
          <p>
            dmk integration test with
            <code className="relative rounded bg-muted px-[0.3rem] py-[0.2rem] font-mono text-sm">
              viem
            </code>
          </p>
          <DMKTest />
        </CardContent>
      </Card>
    </div>
  );
}

export default App;
